import { Dispatch, FC, ReactElement, SetStateAction, useState } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { Button } from '@corratech/pylot-ui'
import s from './NoWishlistItems.module.scss'
import { CreateWishlist } from '../../CreateWishlist'

const items = [
    {
        img: '/wishlist/parchment.svg',
        alt: 'parchment',
        titleKey: 'wishlist|Create your gift list',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    {
        img: '/wishlist/cart.svg',
        alt: 'cart',
        titleKey: 'wishlist|Add products',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    {
        img: '/wishlist/favorite.svg',
        alt: 'favorite',
        titleKey: 'wishlist|Share it',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    }
]

type WishlistHomeProps = {
    setShowForm: Dispatch<SetStateAction<boolean>>
}

const WishlistHome: FC<WishlistHomeProps> = ({ setShowForm }) => {
    const { t } = useTranslation(['wishlist'])

    return (
        <div>
            <div className={s['banner-container']}>
                <div className={s['banner-container-overview']}>
                    <h3>{t('Regala Recuerdos')}</h3>
                    <p>
                        {t(
                            'Obtén 20% de descuento on lorem ipsum dolor sit amet, adipiscing elit. Aenean commodo'
                        )}
                    </p>
                    <Button variant="secondary" aria-label={t('ver productos')}>
                        {t('ver productos')}
                    </Button>
                </div>
                <div className={s['banner-container-image']}>
                    <img src="/wishlist/inspo.svg" alt={t('inspo')} />
                </div>
            </div>
            <h5 className={s['title']}>{t('account||account|My Wish List')}</h5>
            <div className={s['content-container']}>
                {items.map((item, index) => (
                    <div className={s['content-container-items']} key={index}>
                        <div className={s['content-container-items-circle']}>
                            <img src={item.img} alt={item.alt} />
                        </div>
                        <div className={s['content-container-items-caption']}>
                            <h5>{t(item.titleKey)}</h5>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            <Button
                variant="primary"
                aria-label={t('crear lista')}
                onClick={() => setShowForm(true)}
                className={s['button']}
            >
                {t('crear lista')}
            </Button>
        </div>
    )
}

export const NoWishlistItems = (): ReactElement => {
    const [showForm, setShowForm] = useState(false)

    return showForm ? (
        <CreateWishlist setShow={setShowForm} show={showForm} />
    ) : (
        <WishlistHome setShowForm={setShowForm} />
    )
}
